import React, { useState, useEffect } from 'react'
import WorkFlow from '../../components/WorkFlow'
import Layout from '../Layout'
import Banner from '../../components/Banner'
import './style.scss'
import { Button, Grid, Box, FormGroup, Stack } from '@mui/material'
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import TopBar from '../../components/TopBar'
import UserList from './UserList'
import AddUser from './AddUser'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { RESET_ERROR } from '../../Redux/constants/userConstants'
const User = ({ head }) => {
    const AddNewUser = () => {
        setAddModalShow(true);
    }

    const dispatch = useDispatch()
    const [addModalShow, setAddModalShow] = useState(false);

    const { newUserSuccess, error, user } = useSelector(state => state.auth)

    useEffect(() => {
        if (newUserSuccess) {
            toast.success("New User added successfully");
            setAddModalShow(false)
            dispatch({
                type: RESET_ERROR
            })
        }

        if (error) {
            toast.error(error);
            dispatch({
                type: RESET_ERROR
            })
        }
    }, [newUserSuccess, error])




    return (

        <Layout head={head}>
            <Stack direction={"row"} justifyContent="space-between" alignItems={"center"} className='container_topspace'>

                <h1 class='underline'>User Details</h1>
                <Button
                    variant="filled" startIcon={<PersonAddIcon />}
                    style={{ }} onClick={()=>setAddModalShow(true)}>ADD USER</Button>


            </Stack>
            <Box xs={6} md={5} pt={0}>
                <UserList />
            </Box>

            {addModalShow && <AddUser openAddModal={addModalShow} closeAddModal={() => setAddModalShow(false)} />}
        </Layout>
    )
}

export default User
